import { defineStore } from 'pinia';
import { store } from '../index';
import { UserLoginType, UserType } from '@/api/login/types';
import { ElMessageBox } from 'element-plus';
import { useTagsViewStore } from './tagsView';
import router from '@/router';
import { loginOutApi } from '@/api/login';
import { useI18n } from '@/hooks/web/useI18n';

interface UserState {
  userInfo?: UserType;
  tokenKey: string;
  token: string;
  isThreeDays: string; //是否三天免登录,Y 三天免登录 N 不是
  roleRouters?: string[] | AppCustomRouteRecordRaw[];
  publicResourceId: number | undefined; //公共资源id
  rememberMe: boolean;
  loginInfo?: UserLoginType;
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      tokenKey: 'Authorization',
      token: '',
      isThreeDays: 'N',
      roleRouters: undefined,
      publicResourceId: undefined, //公共资源id
      // 记住我
      rememberMe: true,
      loginInfo: undefined,
    };
  },
  getters: {
    getTokenKey(): string {
      return this.tokenKey;
    },
    getToken(): string {
      return this.token;
    },
    getIsThreeDays(): string {
      return this.isThreeDays;
    },
    getUserInfo(): UserType | undefined {
      return this.userInfo;
    },
    getRoleRouters(): string[] | AppCustomRouteRecordRaw[] | undefined {
      return this.roleRouters;
    },
    getRememberMe(): boolean {
      return this.rememberMe;
    },
    getLoginInfo(): UserLoginType | undefined {
      return this.loginInfo;
    },
    // 获取公共资源id
    getPublicResourceId(): number | undefined {
      return this.publicResourceId;
    },
  },
  actions: {
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey;
    },
    setToken(token: string) {
      this.token = token;
    },
    setIsThreeDays(isThreeDays: string) {
      this.isThreeDays = isThreeDays;
    },
    setUserInfo(userInfo?: UserType) {
      this.setPublicResourceId(userInfo?.publicResourceId);
      this.userInfo = userInfo;
    },
    setRoleRouters(roleRouters: string[] | AppCustomRouteRecordRaw[]) {
      this.roleRouters = roleRouters;
    },
    logoutConfirm() {
      const { t } = useI18n();

      ElMessageBox.confirm(t('common.exitTip'), t('common.warmTip'), {
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        type: 'warning',
      })
        .then(async () => {
          //不调用接口，先注释掉
          const res = await loginOutApi().catch(() => {});
          if (res) {
            this.reset();
          }
        })
        .catch(() => {});
    },
    reset() {
      const tagsViewStore = useTagsViewStore();
      tagsViewStore.delAllViews();
      this.setToken('');
      this.setUserInfo(undefined);
      this.setRoleRouters([]);
      router.replace('/login');
    },
    logout() {
      this.reset();
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe;
    },
    setLoginInfo(loginInfo: UserLoginType | undefined) {
      this.loginInfo = loginInfo;
    },
    // 设置公共资源id
    setPublicResourceId(publicResourceId: number | undefined) {
      this.publicResourceId = publicResourceId;
    },
  },
  persist: true,
});

export const useUserStoreWithOut = () => {
  return useUserStore(store);
};
